import {
  ActionType,
  FavoriteState
} from "../../schemas/Favorite/Favorite.Schema";
import * as Constants from "../../utils/constants";
import produce from "immer";

export const initialFavouriteState: FavoriteState = {
  Favorite: [],
  updatedId: {},
  error: {}
};

export default (state = initialFavouriteState, action: ActionType) =>
  produce(state, draft => {
    switch (action.type) {
      case Constants.GET_FAVORITE:
        draft.Favorite = action.payload;
        break;
      case Constants.UPDATE_FAVORITE_LOADS_REDUCER:
        draft.updatedId = action.payload;
        break;
      case Constants.CLEAR_UPDATE_FAVORITE_LOADS_ID:
        draft.updatedId = {};
        break;
    }
  });
